import { c as _c } from "react/compiler-runtime";
// Прочие иконки: профиль, заказы, доставка, рейтинг, подсказки из Figma «OSMIX ЛК Покупателя» (cHkTZXVaiia41bQ9HlRF7O),
// выгрузка SVG 02.10.2026. Цвет — currentColor (задаётся text-*), размер — проп size.
// Файл собран скриптом из audit/DS/icons-svg: правьте рисунок там и пересобирайте.
import { type IconProps, Svg } from "./icon";

/** Мои покупки: меню профиля. Figma: «shopping-bag 1 / Size=L · 24». */
export function ShoppingBagIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6V6.00163C17.4755 6.00489 17.891 6.01471 18.2518 6.04419C18.8139 6.09012 19.3306 6.18868 19.816 6.43597C20.5686 6.81947 21.1805 7.43139 21.564 8.18404C21.8113 8.66937 21.9099 9.18608 21.9558 9.74817C22 10.2894 22 10.9537 22 11.7587V17.2413C22 18.0463 22 18.7106 21.9558 19.2518C21.9099 19.8139 21.8113 20.3306 21.564 20.816C21.1805 21.5686 20.5686 22.1805 19.816 22.564C19.3306 22.8113 18.8139 22.9099 18.2518 22.9558C17.7106 23 17.0463 23 16.2413 23H7.75868C6.95372 23 6.28936 23 5.74817 22.9558C5.18608 22.9099 4.66937 22.8113 4.18404 22.564C3.43139 22.1805 2.81947 21.5686 2.43597 20.816C2.18868 20.3306 2.09012 19.8139 2.04419 19.2518C1.99998 18.7106 1.99999 18.0463 2 17.2413V11.7587C1.99999 10.9537 1.99998 10.2894 2.04419 9.74817C2.09012 9.18608 2.18868 8.66937 2.43597 8.18404C2.81947 7.43139 3.43139 6.81947 4.18404 6.43597C4.66937 6.18868 5.18608 6.09012 5.74817 6.04419C6.10898 6.01471 6.52454 6.00489 7 6.00163V6ZM7 8.00176V10C7 10.5523 7.44772 11 8 11C8.55229 11 9 10.5523 9 10V8H15V10C15 10.5523 15.4477 11 16 11C16.5523 11 17 10.5523 17 10V8.00176C17.4455 8.00489 17.7954 8.01356 18.089 8.03755C18.5274 8.07337 18.7516 8.1383 18.908 8.21799C19.2843 8.40973 19.5903 8.7157 19.782 9.09202C19.8617 9.24842 19.9266 9.47262 19.9624 9.91104C19.9992 10.3611 20 10.9434 20 11.8V17.2C20 18.0566 19.9992 18.6389 19.9624 19.089C19.9266 19.5274 19.8617 19.7516 19.782 19.908C19.5903 20.2843 19.2843 20.5903 18.908 20.782C18.7516 20.8617 18.5274 20.9266 18.089 20.9624C17.6389 20.9992 17.0566 21 16.2 21H7.8C6.94342 21 6.36113 20.9992 5.91104 20.9624C5.47262 20.9266 5.24842 20.8617 5.09202 20.782C4.7157 20.5903 4.40973 20.2843 4.21799 19.908C4.1383 19.7516 4.07337 19.5274 4.03755 19.089C4.00078 18.6389 4 18.0566 4 17.2V11.8C4 10.9434 4.00078 10.3611 4.03755 9.91104C4.07337 9.47262 4.1383 9.24842 4.21799 9.09202C4.40973 8.71569 4.7157 8.40973 5.09202 8.21799C5.24842 8.1383 5.47262 8.07337 5.91104 8.03755C6.20463 8.01356 6.55447 8.00489 7 8.00176ZM15 6H9C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Сумка в кнопке L «В корзину», счётчик товаров идеи. Figma: «shopping-bag 1 / Size=M · 20». */
export function ShoppingBag20Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M5.83464 4.99967C5.83464 2.69849 7.70012 0.833008 10.0013 0.833008C12.3025 0.833008 14.168 2.69849 14.168 4.99967V5.00103C14.5642 5.00375 14.9105 5.01194 15.2112 5.0365C15.6796 5.07477 16.1102 5.15691 16.5146 5.36299C17.1418 5.68256 17.6517 6.1925 17.9713 6.81971C18.1774 7.22415 18.2595 7.65474 18.2978 8.12315C18.3347 8.57414 18.3346 9.12777 18.3346 9.79857V14.3674C18.3346 15.0382 18.3347 15.5919 18.2978 16.0429C18.2595 16.5113 18.1774 16.9419 17.9713 17.3463C17.6517 17.9735 17.1418 18.4834 16.5146 18.803C16.1102 19.0091 15.6796 19.0912 15.2112 19.1295C14.7602 19.1664 14.2065 19.1664 13.5357 19.1663H6.46687C5.79607 19.1664 5.24244 19.1664 4.79145 19.1295C4.32303 19.0912 3.89245 19.0091 3.488 18.803C2.86079 18.4834 2.35086 17.9735 2.03128 17.3463C1.82521 16.9419 1.74307 16.5113 1.7048 16.0429C1.66795 15.5919 1.66796 15.0382 1.66797 14.3674V9.79859C1.66796 9.12778 1.66795 8.57415 1.7048 8.12315C1.74307 7.65474 1.82521 7.22415 2.03128 6.81971C2.35086 6.1925 2.86079 5.68256 3.488 5.36299C3.89245 5.15691 4.32303 5.07477 4.79145 5.0365C5.09212 5.01194 5.43842 5.00375 5.83464 5.00103V4.99967ZM5.83464 6.66781V8.33301C5.83464 8.79324 6.20773 9.16634 6.66797 9.16634C7.12821 9.16634 7.5013 8.79324 7.5013 8.33301V6.66634H12.5013V8.33301C12.5013 8.79324 12.8744 9.16634 13.3346 9.16634C13.7949 9.16634 14.168 8.79324 14.168 8.33301V6.66781C14.5392 6.67042 14.8308 6.67764 15.0754 6.69763C15.4408 6.72748 15.6276 6.78159 15.758 6.848C16.0716 7.00779 16.3265 7.26275 16.4863 7.57636C16.5527 7.70669 16.6068 7.89353 16.6367 8.25887C16.6673 8.63395 16.668 9.11919 16.668 9.83301V14.333C16.668 15.0468 16.6673 15.5321 16.6367 15.9071C16.6068 16.2725 16.5527 16.4593 16.4863 16.5897C16.3265 16.9033 16.0716 17.1582 15.758 17.318C15.6276 17.3844 15.4408 17.4385 15.0754 17.4684C14.7004 17.499 14.2151 17.4997 13.5013 17.4997H6.5013C5.78749 17.4997 5.30224 17.499 4.92717 17.4684C4.56182 17.4385 4.37499 17.3844 4.24465 17.318C3.93105 17.1582 3.67608 16.9033 3.51629 16.5897C3.44988 16.4593 3.39578 16.2725 3.36593 15.9071C3.33528 15.5321 3.33464 15.0468 3.33464 14.333V9.83301C3.33464 9.11919 3.33528 8.63395 3.36593 8.25887C3.39578 7.89353 3.44988 7.70669 3.51629 7.57636C3.67608 7.26275 3.93105 7.00779 4.24465 6.848C4.37499 6.78159 4.56182 6.72748 4.92717 6.69763C5.17183 6.67764 5.46336 6.67042 5.83464 6.66781ZM12.5013 4.99967H7.5013C7.5013 3.61896 8.62059 2.49967 10.0013 2.49967C11.382 2.49967 12.5013 3.61896 12.5013 4.99967Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Заказы: меню профиля. Figma: «shopping-bag 2 / Size=L · 24». */
export function ShoppingBag2Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M8.0826 1.00008C8.13758 1.00012 8.19329 1.00016 8.24977 1.00016H15.7503C15.8067 1.00016 15.8625 1.00012 15.9174 1.00008C16.9268 0.999343 17.6871 0.998791 18.3671 1.25248C18.9647 1.47544 19.5003 1.83807 19.9293 2.31012C20.4174 2.84726 20.6992 3.55336 21.0734 4.49084C21.0938 4.5419 21.1144 4.59365 21.1354 4.64609L21.5852 5.77049C21.5911 5.78529 21.5969 5.7999 21.6027 5.81432C21.7142 6.0928 21.7985 6.30346 21.859 6.52504C21.9124 6.72092 21.9509 6.92058 21.974 7.12229C22.0001 7.35047 22.0001 7.57736 22 7.87731C22 7.89286 22 7.9086 22 7.92455V17.2415C22 18.0464 22 18.7108 21.9558 19.252C21.9099 19.8141 21.8113 20.3308 21.564 20.8161C21.1805 21.5688 20.5686 22.1807 19.816 22.5642C19.3306 22.8115 18.8139 22.91 18.2518 22.956C17.7106 23.0002 17.0463 23.0002 16.2413 23.0002H7.75869C6.95373 23.0002 6.28938 23.0002 5.74819 22.956C5.18609 22.91 4.66939 22.8115 4.18405 22.5642C3.4314 22.1807 2.81948 21.5688 2.43599 20.8161C2.1887 20.3308 2.09013 19.8141 2.04421 19.252C1.99999 18.7108 2 18.0464 2.00001 17.2415L2.00001 7.92455C2.00001 7.9086 2.00001 7.89285 2.00001 7.8773C1.99994 7.57736 1.99989 7.35047 2.02605 7.12229C2.04917 6.92058 2.08762 6.72092 2.14107 6.52504C2.20152 6.30347 2.28584 6.09282 2.39729 5.81436C2.40307 5.79992 2.40892 5.7853 2.41485 5.77049L2.86461 4.64609C2.88558 4.59365 2.90624 4.54191 2.92662 4.49085C3.30082 3.55337 3.58267 2.84726 4.07076 2.31012C4.49971 1.83807 5.03533 1.47544 5.63293 1.25248C6.31292 0.998791 7.0732 0.999343 8.0826 1.00008ZM8.24977 3.00016C6.99656 3.00016 6.62948 3.01534 6.33202 3.12632C6.03322 3.2378 5.76541 3.41911 5.55093 3.65514C5.33742 3.89011 5.18699 4.22529 4.72156 5.38887L4.47705 6.00016H19.523L19.2785 5.38887C18.813 4.22529 18.6626 3.89011 18.4491 3.65514C18.2346 3.41911 17.9668 3.2378 17.668 3.12632C17.3705 3.01534 17.0035 3.00016 15.7503 3.00016H8.24977ZM20 8.00016H4.00001V17.2002C4.00001 18.0567 4.00079 18.639 4.03757 19.0891C4.07339 19.5275 4.13831 19.7517 4.218 19.9081C4.40975 20.2845 4.71571 20.5904 5.09203 20.7822C5.24843 20.8619 5.47264 20.9268 5.91105 20.9626C6.36114 20.9994 6.94343 21.0002 7.80001 21.0002H16.2C17.0566 21.0002 17.6389 20.9994 18.089 20.9626C18.5274 20.9268 18.7516 20.8619 18.908 20.7822C19.2843 20.5904 19.5903 20.2845 19.782 19.9081C19.8617 19.7517 19.9266 19.5275 19.9625 19.0891C19.9992 18.639 20 18.0567 20 17.2002V8.00016ZM8.00001 10.0259C8.5523 10.0259 9.00001 10.4736 9.00001 11.0259V11.8542C9.00001 13.511 10.3432 14.8542 12 14.8542C13.6569 14.8542 15 13.511 15 11.8542V11.0259C15 10.4736 15.4477 10.0259 16 10.0259C16.5523 10.0259 17 10.4736 17 11.0259V11.8542C17 14.6156 14.7614 16.8542 12 16.8542C9.23859 16.8542 7.00001 14.6156 7.00001 11.8542V11.0259C7.00001 10.4736 7.44773 10.0259 8.00001 10.0259Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Посылка: пункт выдачи. Figma: «Package / Size=24». */
export function PackageIcon(t0) {
  const $ = _c(10);
  let props;
  let strokeWidth;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      strokeWidth,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = strokeWidth;
    $[3] = t1;
  } else {
    props = $[1];
    strokeWidth = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  const t2 = strokeWidth ?? 1.5;
  let t3;
  if ($[4] !== t2) {
    t3 = <path d="M16.5 9.3999L7.5 4.2099M3.27 6.9599L12 12.0099L20.73 6.9599M12 22.0799V11.9999M21 15.9999V7.9999C20.9996 7.64918 20.9071 7.30471 20.7315 7.00106C20.556 6.69742 20.3037 6.44526 20 6.2699L13 2.2699C12.696 2.09437 12.3511 2.00195 12 2.00195C11.6489 2.00195 11.304 2.09437 11 2.2699L4 6.2699C3.69626 6.44526 3.44398 6.69742 3.26846 7.00106C3.09294 7.30471 3.00036 7.64918 3 7.9999V15.9999C3.00036 16.3506 3.09294 16.6951 3.26846 16.9987C3.44398 17.3024 3.69626 17.5545 4 17.7299L11 21.7299C11.304 21.9054 11.6489 21.9979 12 21.9979C12.3511 21.9979 12.696 21.9054 13 21.7299L20 17.7299C20.3037 17.5545 20.556 17.3024 20.7315 16.9987C20.9071 16.6951 20.9996 16.3506 21 15.9999Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== size || $[8] !== t3) {
    t4 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t3}</Svg>;
    $[6] = props;
    $[7] = size;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}

/** Коробка: статус заказа. Figma: «Box / Size=20». */
export function BoxIcon(t0) {
  const $ = _c(10);
  let props;
  let strokeWidth;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      strokeWidth,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = strokeWidth;
    $[3] = t1;
  } else {
    props = $[1];
    strokeWidth = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 20 : t1;
  const t2 = strokeWidth ?? 1.4;
  let t3;
  if ($[4] !== t2) {
    t3 = <path d="M2.725 5.79959L10 10.0079L17.275 5.79959M10 18.3996V9.99959M17.5 13.3329V6.66626C17.4997 6.37399 17.4225 6.08693 17.2763 5.83389C17.13 5.58086 16.9198 5.37073 16.6667 5.22459L10.8333 1.89126C10.58 1.74498 10.2926 1.66797 10 1.66797C9.70744 1.66797 9.42003 1.74498 9.16667 1.89126L3.33333 5.22459C3.08022 5.37073 2.86998 5.58086 2.72372 5.83389C2.57745 6.08693 2.5003 6.37399 2.5 6.66626V13.3329C2.5003 13.6252 2.57745 13.9122 2.72372 14.1653C2.86998 14.4183 3.08022 14.6285 3.33333 14.7746L9.16667 18.1079C9.42003 18.2542 9.70744 18.3312 10 18.3312C10.2926 18.3312 10.58 18.2542 10.8333 18.1079L16.6667 14.7746C16.9198 14.6285 17.13 14.4183 17.2763 14.1653C17.4225 13.9122 17.4997 13.6252 17.5 13.3329Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== size || $[8] !== t3) {
    t4 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t3}</Svg>;
    $[6] = props;
    $[7] = size;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}

/** Карта: способы оплаты в меню профиля. Figma: «Outline/card». */
export function CardIcon(t0) {
  const $ = _c(19);
  let props;
  let strokeWidth;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      strokeWidth,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = strokeWidth;
    $[3] = t1;
  } else {
    props = $[1];
    strokeWidth = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  const t2 = strokeWidth ?? 1.5;
  let t3;
  if ($[4] !== t2) {
    t3 = <path d="M2 8.50488H22" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" strokeWidth={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = strokeWidth ?? 1.5;
  let t5;
  if ($[6] !== t4) {
    t5 = <path d="M6 16.5049H8" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" strokeWidth={t4} />;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = strokeWidth ?? 1.5;
  let t7;
  if ($[8] !== t6) {
    t7 = <path d="M10.5 16.5049H14.5" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" strokeWidth={t6} />;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = strokeWidth ?? 1.5;
  let t9;
  if ($[10] !== t8) {
    t9 = <path d="M6.44 3.50488H17.55C21.11 3.50488 22 4.38488 22 7.89488V16.1049C22 19.6149 21.11 20.4949 17.56 20.4949H6.44C2.89 20.5049 2 19.6249 2 16.1149V7.89488C2 4.38488 2.89 3.50488 6.44 3.50488Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={t8} />;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== props || $[13] !== size || $[14] !== t3 || $[15] !== t5 || $[16] !== t7 || $[17] !== t9) {
    t10 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t3}{t5}{t7}{t9}</Svg>;
    $[12] = props;
    $[13] = size;
    $[14] = t3;
    $[15] = t5;
    $[16] = t7;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}

/** Купон: «Мои купоны» в меню профиля (fd-promo-34). В макете раздела нет —
 *  контур в стиле Outline-набора (24, обводка 1.5). */
export function TicketIcon(t0) {
  const $ = _c(19);
  let props;
  let strokeWidth;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      strokeWidth,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = strokeWidth;
    $[3] = t1;
  } else {
    props = $[1];
    strokeWidth = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  const t2 = strokeWidth ?? 1.5;
  let t3;
  if ($[4] !== t2) {
    t3 = <path d="M19.5 12.5C19.5 11.12 20.62 10 22 10V9C22 5 21 4 17 4H7C3 4 2 5 2 9V9.5C3.38 9.5 4.5 10.62 4.5 12C4.5 13.38 3.38 14.5 2 14.5V15C2 19 3 20 7 20H17C21 20 22 19 22 15C20.62 15 19.5 13.88 19.5 12.5Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = strokeWidth ?? 1.5;
  let t5;
  if ($[6] !== t4) {
    t5 = <path d="M9 15L15 9" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={t4} />;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = (strokeWidth ?? 1.5) + 0.5;
  let t7;
  if ($[8] !== t6) {
    t7 = <path d="M14.9945 14.5H15.0035" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={t6} />;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = (strokeWidth ?? 1.5) + 0.5;
  let t9;
  if ($[10] !== t8) {
    t9 = <path d="M8.99451 9.5H9.00349" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={t8} />;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== props || $[13] !== size || $[14] !== t3 || $[15] !== t5 || $[16] !== t7 || $[17] !== t9) {
    t10 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t3}{t5}{t7}{t9}</Svg>;
    $[12] = props;
    $[13] = size;
    $[14] = t3;
    $[15] = t5;
    $[16] = t7;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}

/** Кошелёк залитый (лендинг продавца). Figma: «Bold/Wallet». */
export function WalletBoldIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M17.7689 8.3818H22C22 4.98459 19.9644 3 16.5156 3H7.48444C4.03556 3 2 4.98459 2 8.33847V15.6615C2 19.0154 4.03556 21 7.48444 21H16.5156C19.9644 21 22 19.0154 22 15.6615V15.3495H17.7689C15.8052 15.3495 14.2133 13.7975 14.2133 11.883C14.2133 9.96849 15.8052 8.41647 17.7689 8.41647V8.3818ZM17.7689 9.87241H21.2533C21.6657 9.87241 22 10.1983 22 10.6004V13.131C21.9952 13.5311 21.6637 13.8543 21.2533 13.8589H17.8489C16.8548 13.872 15.9855 13.2084 15.76 12.2643C15.6471 11.6783 15.8056 11.0736 16.1931 10.6122C16.5805 10.1509 17.1573 9.88007 17.7689 9.87241ZM17.9205 12.533H18.2493C18.6715 12.533 19.0138 12.1993 19.0138 11.7877C19.0138 11.3761 18.6715 11.0424 18.2493 11.0424H17.9205C17.7185 11.0401 17.5241 11.1167 17.3804 11.2551C17.2368 11.3935 17.156 11.5821 17.156 11.779C17.156 12.1921 17.4968 12.5282 17.9205 12.533ZM6.7371 8.38185H12.3815C12.8037 8.38185 13.146 8.04816 13.146 7.63654C13.146 7.22492 12.8037 6.89124 12.3815 6.89124H6.7371C6.31836 6.89121 5.97753 7.21964 5.97266 7.62787C5.97263 8.04092 6.31348 8.3771 6.7371 8.38185Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Метка на карте 24. Figma: «marker-pin 1 / Size=L · 24». */
export function MarkerPinIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M12 4C8.13401 4 5 7.13401 5 11C5 13.1606 6.01657 15.131 7.37893 16.7944C8.73705 18.4526 10.3701 19.7201 11.4331 20.4521C11.6154 20.5776 11.7018 20.636 11.7724 20.6759C11.8207 20.7031 11.8453 20.7121 11.8787 20.7204C11.8795 20.7206 11.8897 20.7226 11.9101 20.7246C11.9351 20.7271 11.9661 20.7288 12 20.7288C12.0339 20.7288 12.0649 20.7271 12.0899 20.7246C12.1103 20.7226 12.1205 20.7206 12.1213 20.7204C12.1547 20.7121 12.1793 20.7031 12.2276 20.6759C12.2982 20.636 12.3846 20.5776 12.5669 20.4521C13.6299 19.7201 15.263 18.4526 16.6211 16.7944C17.9834 15.131 19 13.1606 19 11C19 7.13401 15.866 4 12 4ZM3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11C21 13.7997 19.6872 16.2072 18.1683 18.0616C16.6453 19.9212 14.8453 21.3115 13.7012 22.0993C13.6838 22.1113 13.6663 22.1234 13.6489 22.1354C13.3533 22.3397 13.0447 22.5529 12.5972 22.663C12.2406 22.7507 11.7594 22.7507 11.4028 22.663C10.9553 22.5529 10.6467 22.3397 10.3511 22.1354C10.3337 22.1234 10.3162 22.1113 10.2988 22.0993C9.15469 21.3115 7.35474 19.9212 5.83166 18.0616C4.31283 16.2072 3 13.7997 3 11ZM12 9.40161C11.1172 9.40161 10.4016 10.1173 10.4016 11.0001C10.4016 11.8829 11.1172 12.5985 12 12.5985C12.8828 12.5985 13.5984 11.8829 13.5984 11.0001C13.5984 10.1173 12.8828 9.40161 12 9.40161ZM8.40155 11.0001C8.40155 9.01269 10.0126 7.40161 12 7.40161C13.9874 7.40161 15.5984 9.01269 15.5984 11.0001C15.5984 12.9874 13.9874 14.5985 12 14.5985C10.0126 14.5985 8.40155 12.9874 8.40155 11.0001Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Метка 20: доставка в карточке товара. Figma: «marker-pin 1 / Size=M · 20». */
export function MarkerPin20Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M10 3.33317C6.77834 3.33317 4.16667 5.94484 4.16667 9.1665C4.16667 10.967 5.01381 12.609 6.14911 13.9952C7.28087 15.377 8.64173 16.4332 9.52759 17.0432C9.67948 17.1478 9.75148 17.1965 9.81034 17.2297C9.85055 17.2524 9.87109 17.2599 9.89891 17.2669C9.89962 17.267 9.90812 17.2686 9.92507 17.2704C9.94588 17.2725 9.97174 17.2738 10 17.2738C10.0283 17.2738 10.0541 17.2725 10.0749 17.2704C10.0919 17.2686 10.1004 17.267 10.1011 17.2669C10.1289 17.2599 10.1495 17.2524 10.1897 17.2297C10.2485 17.1965 10.3205 17.1478 10.4724 17.0432C11.3583 16.4332 12.7191 15.377 13.8509 13.9952C14.9862 12.609 15.8333 10.967 15.8333 9.1665C15.8333 5.94484 13.2217 3.33317 10 3.33317ZM2.5 9.1665C2.5 5.02437 5.85786 1.6665 10 1.6665C14.1421 1.6665 17.5 5.02437 17.5 9.1665C17.5 11.4996 16.406 13.5058 15.1403 15.0512C13.8711 16.6009 12.3711 17.7594 11.4177 18.4159C11.4031 18.4259 11.3886 18.436 11.3741 18.446C11.1277 18.6162 10.8705 18.7939 10.4977 18.8857C10.2005 18.9588 9.79953 18.9588 9.50233 18.8857C9.12945 18.7939 8.87227 18.6162 8.62594 18.446C8.61138 18.436 8.59686 18.4259 8.58235 18.4159C7.62891 17.7594 6.12895 16.6009 4.85972 15.0512C3.59403 13.5058 2.5 11.4996 2.5 9.1665ZM10 7.83451C9.26433 7.83451 8.66796 8.43089 8.66796 9.16655C8.66796 9.90222 9.26433 10.4986 10 10.4986C10.7357 10.4986 11.332 9.90222 11.332 9.16655C11.332 8.43089 10.7357 7.83451 10 7.83451ZM7.00129 9.16655C7.00129 7.51041 8.34386 6.16785 10 6.16785C11.6561 6.16785 12.9987 7.51041 12.9987 9.16655C12.9987 10.8227 11.6561 12.1653 10 12.1653C8.34386 12.1653 7.00129 10.8227 7.00129 9.16655Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Закреплённый отзыв (булавка). Figma: «pin 2 / Size=S · 16». */
export function PinIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M8.2145 1.79234C8.76689 1.54208 9.38809 1.48758 9.97562 1.63783C10.3574 1.73545 10.6823 1.93916 11.0042 2.19528C11.3158 2.44312 11.6727 2.78049 12.1075 3.19137L12.76 3.8081C13.1948 4.21896 13.5518 4.55631 13.8168 4.85336C14.0907 5.16035 14.3124 5.47325 14.4314 5.84887C14.6146 6.42698 14.5952 7.05027 14.3765 7.6159C14.2344 7.98341 13.9937 8.28195 13.7013 8.57135C13.4184 8.85138 13.0412 9.16592 12.5818 9.54901L11.7982 10.2024C11.6729 10.3069 11.6366 10.3377 11.6045 10.3689C11.5012 10.4693 11.4148 10.5857 11.3488 10.7137C11.3282 10.7534 11.3093 10.7971 11.2456 10.9474L11.2389 10.9631C11.0848 11.3269 10.9597 11.6221 10.8475 11.8547C10.7336 12.0909 10.6137 12.3048 10.457 12.4877C9.66975 13.4066 8.36252 13.6803 7.27279 13.1544C7.05584 13.0497 6.86015 12.9019 6.66112 12.7313C6.46504 12.5632 6.23199 12.343 5.94487 12.0716L5.35295 11.5122L2.7176 14.3007C2.4647 14.5683 2.04276 14.5802 1.77516 14.3273C1.50757 14.0744 1.49565 13.6525 1.74855 13.3849L4.38391 10.5964L3.91407 10.1524C3.89195 10.1315 3.8702 10.1109 3.8488 10.0907C3.49823 9.75966 3.24531 9.52084 3.08887 9.29758C2.19815 8.02647 2.57698 6.26622 3.91172 5.47406C4.14616 5.33492 4.47493 5.22128 4.93065 5.06375C4.95846 5.05414 4.98674 5.04437 5.0155 5.03441C5.13675 4.99245 5.17211 4.97992 5.20434 4.96659C5.40274 4.8845 5.57838 4.75571 5.71632 4.59118C5.73873 4.56445 5.7613 4.53448 5.83778 4.43147L6.38575 3.69335C6.7423 3.21305 7.03506 2.81869 7.29868 2.52039C7.57111 2.21211 7.8556 1.95494 8.2145 1.79234ZM9.64529 2.92959C9.35152 2.85447 9.04092 2.88172 8.76472 3.00685C8.65184 3.05799 8.51472 3.15784 8.29778 3.40333C8.07633 3.65391 7.81719 4.00202 7.43883 4.51168L6.89844 5.23959C6.83606 5.32363 6.78897 5.38709 6.73807 5.4478C6.46218 5.77687 6.11091 6.03444 5.71412 6.19862C5.64091 6.22891 5.56623 6.25475 5.46732 6.28897L5.45161 6.29441C4.87581 6.4937 4.6928 6.56097 4.59223 6.62066C3.92485 7.01674 3.73544 7.89687 4.1808 8.53242C4.24791 8.6282 4.38705 8.7648 4.82989 9.18331L6.84826 11.0908C7.15076 11.3767 7.36033 11.5745 7.52889 11.719C7.69733 11.8634 7.79006 11.9236 7.85229 11.9536C8.39716 12.2166 9.05078 12.0797 9.44438 11.6203C9.48934 11.5678 9.55012 11.4754 9.64648 11.2756C9.74292 11.0756 9.85552 10.8104 10.0179 10.4271L10.0261 10.4077C10.0781 10.285 10.1174 10.1922 10.164 10.102C10.2962 9.84603 10.4689 9.61319 10.6755 9.4125C10.7484 9.34171 10.8258 9.27721 10.9281 9.19187L11.7053 8.5438C12.1928 8.13728 12.5257 7.85891 12.7634 7.62367C12.9963 7.39322 13.0882 7.25068 13.1329 7.13509C13.2422 6.85227 13.2519 6.54063 13.1603 6.25157C13.1229 6.13344 13.04 5.98547 12.8219 5.74101C12.5992 5.49147 12.2842 5.19298 11.8229 4.75699L11.213 4.18056C10.7516 3.74456 10.4358 3.4469 10.1741 3.2387C9.91776 3.03474 9.76535 2.96029 9.64529 2.92959Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 16 16" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Часы: режим работы ПВЗ. Figma: «clock / Size=L · 24». */
export function ClockIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 5.5C12.5523 5.5 13 5.94772 13 6.5V11.5858L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12V6.5C11 5.94772 11.4477 5.5 12 5.5Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Звезда рейтинга 16. Figma: «Bold/Star». */
export function StarIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M11.9446 9.54699C11.7719 9.71432 11.6926 9.95632 11.7319 10.1937L12.3246 13.4737C12.3746 13.7517 12.2573 14.033 12.0246 14.1937C11.7966 14.3603 11.4933 14.3803 11.2446 14.247L8.29195 12.707C8.18928 12.6523 8.07528 12.623 7.95862 12.6197H7.77795C7.71528 12.629 7.65395 12.649 7.59795 12.6797L4.64462 14.227C4.49862 14.3003 4.33328 14.3263 4.17128 14.3003C3.77662 14.2257 3.51328 13.8497 3.57795 13.453L4.17128 10.173C4.21062 9.93366 4.13128 9.69032 3.95862 9.52032L1.55128 7.18699C1.34995 6.99166 1.27995 6.69833 1.37195 6.43366C1.46128 6.16966 1.68928 5.97699 1.96462 5.93366L5.27795 5.45299C5.52995 5.42699 5.75128 5.27366 5.86462 5.04699L7.32462 2.05366C7.35928 1.98699 7.40395 1.92566 7.45795 1.87366L7.51795 1.82699C7.54928 1.79233 7.58528 1.76366 7.62528 1.74033L7.69795 1.71366L7.81128 1.66699H8.09195C8.34262 1.69299 8.56328 1.84299 8.67862 2.06699L10.1579 5.04699C10.2646 5.26499 10.4719 5.41633 10.7113 5.45299L14.0246 5.93366C14.3046 5.97366 14.5386 6.16699 14.6313 6.43366C14.7186 6.70099 14.6433 6.99433 14.4379 7.18699L11.9446 9.54699Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 16 16" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Звезда оценки в отзыве 32 (рамка 36). Figma: «Bold/Star». */
export function Star32Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 36 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M26.8783 21.48C26.4898 21.8565 26.3113 22.401 26.3998 22.935L27.7333 30.315C27.8458 30.9405 27.5818 31.5735 27.0583 31.935C26.5453 32.31 25.8628 32.355 25.3033 32.055L18.6598 28.59C18.4288 28.467 18.1723 28.401 17.9098 28.3935H17.5033C17.3623 28.4145 17.2243 28.4595 17.0983 28.5285L10.4533 32.01C10.1248 32.175 9.75281 32.2335 9.38831 32.175C8.50031 32.007 7.90781 31.161 8.05331 30.2685L9.38831 22.8885C9.47681 22.35 9.29831 21.8025 8.90981 21.42L3.49331 16.17C3.04031 15.7305 2.88281 15.0705 3.08981 14.475C3.29081 13.881 3.80381 13.4475 4.42331 13.35L11.8783 12.2685C12.4453 12.21 12.9433 11.865 13.1983 11.355L16.4833 4.62C16.5613 4.47 16.6618 4.332 16.7833 4.215L16.9183 4.11C16.9888 4.032 17.0698 3.9675 17.1598 3.915L17.3233 3.855L17.5783 3.75H18.2098C18.7738 3.8085 19.2703 4.146 19.5298 4.65L22.8583 11.355C23.0983 11.8455 23.5648 12.186 24.1033 12.2685L31.5583 13.35C32.1883 13.44 32.7148 13.875 32.9233 14.475C33.1198 15.0765 32.9503 15.7365 32.4883 16.17L26.8783 21.48Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 36 36" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Отзывы: меню профиля. Figma: «thumb-up / Size=L · 24». */
export function ThumbUpIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M13.1839 3.00036C13.1553 3.00003 13.1178 3.00001 13.0565 3.00001C12.9429 3.00001 12.9196 3.00029 12.9015 3.00116C12.5497 3.01798 12.2328 3.21856 12.067 3.52923C12.0584 3.54528 12.0482 3.56623 11.9996 3.66884L8.18359 11.7249V21H12.5594C14.9157 21 15.8453 20.9862 16.6105 20.7174C17.6571 20.3497 18.5517 19.6444 19.1535 18.7124C19.5935 18.0311 19.8239 17.1304 20.3738 14.8392C20.5814 13.974 20.7236 13.3787 20.7991 12.914C20.8737 12.4546 20.8651 12.2187 20.8295 12.0606C20.6966 11.4705 20.3038 10.9722 19.761 10.7053C19.6158 10.6339 19.3881 10.5704 18.923 10.5357C18.4525 10.5007 17.8391 10.5 16.9476 10.5L16.9172 10.5C16.5875 10.5 16.2909 10.5 16.0432 10.4829C15.7788 10.4646 15.4964 10.4234 15.2125 10.3037C14.6115 10.0503 14.1333 9.57214 13.8799 8.97114C13.7603 8.68738 13.719 8.40526 13.7007 8.14103C13.6836 7.89359 13.6836 7.59749 13.6836 7.26851L13.6836 3.62711C13.6836 3.56581 13.6836 3.5283 13.6832 3.49972C13.6829 3.4724 13.6824 3.46564 13.6825 3.46676C13.6658 3.21682 13.4668 3.01778 13.2168 3.00112C13.218 3.00119 13.2112 3.00068 13.1839 3.00036ZM6.18359 20.9983V12.0018C5.73807 12.0049 5.38822 12.0136 5.09463 12.0376C4.65622 12.0734 4.43201 12.1383 4.27561 12.218C3.89929 12.4097 3.59333 12.7157 3.40158 13.092C3.32189 13.2484 3.25697 13.4726 3.22115 13.9111C3.18437 14.3611 3.18359 14.9434 3.18359 15.8V17.2C3.18359 18.0566 3.18437 18.6389 3.22115 19.089C3.25697 19.5274 3.32189 19.7516 3.40158 19.908C3.59333 20.2843 3.89929 20.5903 4.27561 20.782C4.43201 20.8617 4.65622 20.9266 5.09463 20.9625C5.38822 20.9864 5.73807 20.9951 6.18359 20.9983ZM6.7876 10L10.1999 2.79638C10.2365 2.71904 10.2684 2.65154 10.3025 2.58766C10.7998 1.65566 11.7507 1.05392 12.8059 1.00344C12.8782 0.99998 12.9529 0.999995 13.0385 1.00001L13.0565 1.00001C13.0644 1.00001 13.0723 1.00001 13.0802 1.00001C13.1739 0.999967 13.2655 0.999928 13.3498 1.00555C14.5996 1.08884 15.5948 2.08405 15.6781 3.33377C15.6837 3.41807 15.6836 3.50972 15.6836 3.60341C15.6836 3.61129 15.6836 3.6192 15.6836 3.62711V7.23808C15.6836 7.60704 15.6842 7.83289 15.6959 8.00275C15.7014 8.08194 15.7083 8.13046 15.7143 8.16038C15.7171 8.17464 15.7195 8.18349 15.7209 8.18828L15.7224 8.1931L15.7228 8.19418C15.7735 8.31438 15.8692 8.41008 15.9894 8.46075C15.9889 8.46055 15.9889 8.46055 15.9894 8.46075C15.9936 8.46246 16.0369 8.47769 16.1813 8.48767C16.3515 8.49946 16.578 8.50001 16.9476 8.50001H16.9866C17.8297 8.5 18.5179 8.5 19.0716 8.54127C19.6392 8.58358 20.1627 8.67408 20.6436 8.91057C21.7292 9.44445 22.5149 10.441 22.7807 11.6212C22.8984 12.1438 22.8644 12.6734 22.7733 13.2346C22.6844 13.7819 22.524 14.4499 22.3277 15.268L22.3186 15.3059C22.3021 15.3744 22.2859 15.442 22.2699 15.5088C21.7855 17.5289 21.4825 18.7927 20.8337 19.7974C19.9912 21.1021 18.7387 22.0895 17.2734 22.6043C16.145 23.0007 14.8454 23.0005 12.7681 23C12.6994 23 12.6298 23 12.5594 23H6.94227C6.13731 23 5.47296 23 4.93177 22.9558C4.36967 22.9099 3.85297 22.8113 3.36763 22.564C2.61498 22.1805 2.00306 21.5686 1.61957 20.816C1.37228 20.3306 1.27371 19.8139 1.22779 19.2518C1.18357 18.7106 1.18358 18.0463 1.18359 17.2413V15.7587C1.18358 14.9537 1.18357 14.2894 1.22779 13.7482C1.27371 13.1861 1.37228 12.6694 1.61957 12.1841C2.00306 11.4314 2.61498 10.8195 3.36763 10.436C3.85297 10.1887 4.36967 10.0901 4.93177 10.0442C5.4379 10.0029 6.05175 10.0002 6.7876 10Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Сердце тонкое 24: кнопка «В избранное» быстрого просмотра. Figma: «heart / Size=L · 24». */
export function HeartLineIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M12.0079 3.79846C9.67141 1.70612 6.20666 1.27734 3.52219 3.63753C0.628635 6.18154 0.215488 10.4482 2.49543 13.4671C3.91914 15.3522 7.64283 18.8754 9.73785 20.8134L9.76319 20.8369C10.0159 21.0707 10.2478 21.2852 10.4586 21.4504C10.6885 21.6305 10.9486 21.7976 11.2728 21.8974C11.7464 22.0432 12.27 22.0432 12.7436 21.8974C13.0678 21.7976 13.3279 21.6305 13.5578 21.4504C13.7686 21.2852 14.0005 21.0707 14.2533 20.8368L14.2786 20.8134C16.3736 18.8754 20.0973 15.3522 21.521 13.4671C23.7924 10.4594 23.4437 6.15994 20.4839 3.62857C17.7698 1.30737 14.3424 1.70482 12.0079 3.79846ZM11.3631 4.45207C11.3623 4.45292 11.3624 4.45284 11.3632 4.45197L11.3631 4.45207ZM12.6531 4.45185C12.6536 4.45232 12.6538 4.45256 12.6538 4.45254C12.6537 4.45252 12.6536 4.45233 12.6532 4.45194L12.6531 4.45185ZM11.1324 5.75126C9.42238 3.80932 6.80544 3.41397 4.84277 5.13955C2.73436 6.99326 2.4433 10.0794 4.09143 12.2617C5.38287 13.9718 8.94834 17.3586 11.096 19.3452C11.3824 19.6102 11.5538 19.7677 11.6921 19.8761C11.8183 19.975 11.8588 19.9851 11.8611 19.9859C11.9514 20.0137 12.065 20.0137 12.1553 19.9859L12.1555 19.9858C12.1597 19.9846 12.2012 19.9725 12.3243 19.8761C12.4626 19.7677 12.634 19.6102 12.9205 19.3452C15.0681 17.3586 18.6335 13.9718 19.925 12.2617C21.5816 10.0682 21.3121 6.96861 19.184 5.1485C17.1691 3.42525 14.5846 3.81919 12.8842 5.75107C12.8832 5.7522 12.8819 5.75364 12.8804 5.75537C12.8645 5.77358 12.821 5.82331 12.7755 5.86734C12.7241 5.91716 12.5885 6.04301 12.3747 6.11858C12.1369 6.20261 11.8797 6.20264 11.6419 6.11865C11.4281 6.04314 11.2925 5.91733 11.2411 5.8675C11.1956 5.82348 11.152 5.77374 11.1361 5.75555C11.1346 5.75383 11.1333 5.75239 11.1324 5.75126Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Сердце тонкое 16 в кнопке S. Figma: «heart / Size=S · 16». */
export function HeartLine16Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M8.00524 2.53198C6.4476 1.13709 4.13777 0.851237 2.34813 2.42469C0.41909 4.1207 0.143659 6.96511 1.66362 8.97772C2.61276 10.2345 5.09522 12.5833 6.4919 13.8753L6.5088 13.8909C6.67729 14.0468 6.83189 14.1898 6.97239 14.2999C7.12568 14.42 7.29907 14.5314 7.51518 14.5979C7.83096 14.6951 8.17999 14.6951 8.49576 14.5979C8.71188 14.5314 8.88527 14.42 9.03856 14.2999C9.17906 14.1898 9.33367 14.0468 9.50217 13.8909L9.51905 13.8753C10.9157 12.5833 13.3982 10.2345 14.3473 8.97772C15.8616 6.97261 15.6291 4.1063 13.6559 2.41872C11.8466 0.871257 9.56157 1.13622 8.00524 2.53198ZM7.57538 2.96772C7.57487 2.96829 7.57491 2.96823 7.57544 2.96766L7.57538 2.96772ZM8.43542 2.96757C8.43571 2.96789 8.43585 2.96805 8.43584 2.96803C8.43583 2.96802 8.43571 2.96789 8.43548 2.96764L8.43542 2.96757ZM7.42157 3.83385C6.28159 2.53922 4.53696 2.27566 3.22851 3.42604C1.82291 4.66185 1.62887 6.7193 2.72762 8.17417C3.58858 9.31418 5.96556 11.5721 7.39731 12.8965C7.58825 13.0731 7.70252 13.1781 7.79475 13.2504C7.87889 13.3163 7.90585 13.3231 7.90742 13.3236C7.96762 13.3421 8.04333 13.3421 8.10353 13.3236L8.1037 13.3235C8.10648 13.3227 8.13416 13.3147 8.21619 13.2504C8.30843 13.1781 8.42269 13.0731 8.61364 12.8965C10.0454 11.5721 12.4224 9.31418 13.2833 8.17417C14.3877 6.7118 14.2081 4.64541 12.7893 3.43201C11.446 2.28317 9.72308 2.5458 8.58947 3.83372C8.58881 3.83448 8.58797 3.83544 8.58696 3.83659C8.57634 3.84873 8.54733 3.88188 8.51702 3.91123C8.48272 3.94445 8.39236 4.02835 8.24981 4.07873C8.09127 4.13475 7.91983 4.13477 7.76128 4.07878C7.61873 4.02843 7.52835 3.94456 7.49404 3.91134C7.46372 3.88199 7.43469 3.84884 7.42408 3.8367C7.42307 3.83556 7.42223 3.8346 7.42157 3.83385Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 16 16" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Инфо в круге 24 (страница магазина). Figma: «Outline/Info Circle». */
export function InfoCircleIcon(t0) {
  const $ = _c(9);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M12 20.5C16.687 20.5 20.5 16.687 20.5 12C20.5 7.313 16.687 3.5 12 3.5C7.313 3.5 3.5 7.313 3.5 12C3.5 16.687 7.313 20.5 12 20.5ZM12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2Z" fill="currentColor" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M12.0078 10.6269C12.4218 10.6269 12.7578 10.9629 12.7578 11.3769L12.7578 15.7959C12.7578 16.2099 12.4218 16.5459 12.0078 16.5459C11.5938 16.5459 11.2578 16.2099 11.2578 15.7959L11.2578 11.3769C11.2578 10.9629 11.5938 10.6269 12.0078 10.6269Z" fill="currentColor" />;
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M11.9989 7.2041C12.5519 7.2041 13.0039 7.6511 13.0039 8.2041C13.0039 8.7571 12.5609 9.2041 12.0089 9.2041L11.9989 9.2041C11.4459 9.2041 10.9989 8.7571 10.9989 8.2041C10.9989 7.6511 11.4459 7.2041 11.9989 7.2041Z" fill="currentColor" />;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props || $[7] !== size) {
    t5 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}{t3}{t4}</Svg>;
    $[6] = props;
    $[7] = size;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}

/** Инфо 20: подсказки корзины. Figma: «info-circle / Size=L · 24». */
export function InfoCircle20Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M9.9987 2.49967C5.85656 2.49967 2.4987 5.85754 2.4987 9.99967C2.4987 14.1418 5.85656 17.4997 9.9987 17.4997C14.1408 17.4997 17.4987 14.1418 17.4987 9.99967C17.4987 5.85754 14.1408 2.49967 9.9987 2.49967ZM0.832031 9.99967C0.832031 4.93706 4.93609 0.833008 9.9987 0.833008C15.0613 0.833008 19.1654 4.93706 19.1654 9.99967C19.1654 15.0623 15.0613 19.1663 9.9987 19.1663C4.93609 19.1663 0.832031 15.0623 0.832031 9.99967ZM9.22966 6.66632C9.22966 6.20608 9.60275 5.83298 10.063 5.83298H10.0713C10.5316 5.83298 10.9047 6.20608 10.9047 6.66632C10.9047 7.12655 10.5316 7.49965 10.0713 7.49965H10.063C9.60275 7.49965 9.22966 7.12655 9.22966 6.66632ZM10.0713 8.74967C10.5316 8.74967 10.9047 9.12277 10.9047 9.58301V13.333C10.9047 13.7932 10.5316 14.1663 10.0713 14.1663C9.61108 14.1663 9.23799 13.7932 9.23799 13.333V9.58301C9.23799 9.12277 9.61108 8.74967 10.0713 8.74967Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Инфо в квадрате: поддержка в меню профиля. Figma: «Outline/Info Square». */
export function InfoSquareIcon(t0) {
  const $ = _c(9);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M7.664 3.5C5.135 3.5 3.5 5.233 3.5 7.916V16.084C3.5 18.767 5.135 20.5 7.664 20.5H16.332C18.864 20.5 20.5 18.767 20.5 16.084V7.916C20.5 5.233 18.864 3.5 16.334 3.5H7.664ZM16.332 22H7.664C4.276 22 2 19.622 2 16.084V7.916C2 4.378 4.276 2 7.664 2H16.334C19.723 2 22 4.378 22 7.916V16.084C22 19.622 19.723 22 16.332 22Z" fill="currentColor" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M11.9922 16.75C11.5782 16.75 11.2422 16.414 11.2422 16V12C11.2422 11.586 11.5782 11.25 11.9922 11.25C12.4062 11.25 12.7422 11.586 12.7422 12V16C12.7422 16.414 12.4062 16.75 11.9922 16.75Z" fill="currentColor" />;
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M11.9972 9.2041C11.4442 9.2041 10.9922 8.7571 10.9922 8.2041C10.9922 7.6511 11.4352 7.2041 11.9872 7.2041H11.9972C12.5502 7.2041 12.9972 7.6511 12.9972 8.2041C12.9972 8.7571 12.5502 9.2041 11.9972 9.2041Z" fill="currentColor" />;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props || $[7] !== size) {
    t5 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}{t3}{t4}</Svg>;
    $[6] = props;
    $[7] = size;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}

/** Предупреждение 16 в поле (ошибка). Figma: «alert 1 / Size=S · 16». */
export function AlertIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M8.0013 2.00008C4.68759 2.00008 2.0013 4.68637 2.0013 8.00008C2.0013 11.3138 4.68759 14.0001 8.0013 14.0001C11.315 14.0001 14.0013 11.3138 14.0013 8.00008C14.0013 4.68637 11.315 2.00008 8.0013 2.00008ZM0.667969 8.00008C0.667969 3.94999 3.95121 0.666748 8.0013 0.666748C12.0514 0.666748 15.3346 3.94999 15.3346 8.00008C15.3346 12.0502 12.0514 15.3334 8.0013 15.3334C3.95121 15.3334 0.667969 12.0502 0.667969 8.00008ZM8.0013 4.66675C8.36949 4.66675 8.66797 4.96522 8.66797 5.33341V8.66675C8.66797 9.03494 8.36949 9.33341 8.0013 9.33341C7.63311 9.33341 7.33463 9.03494 7.33463 8.66675V5.33341C7.33463 4.96522 7.63311 4.66675 8.0013 4.66675ZM7.33463 10.6667C7.33463 10.2986 7.63311 10.0001 8.0013 10.0001H8.00797C8.37616 10.0001 8.67463 10.2986 8.67463 10.6667C8.67463 11.0349 8.37616 11.3334 8.00797 11.3334H8.0013C7.63311 11.3334 7.33463 11.0349 7.33463 10.6667Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 16 16" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Лупа тонкая 16 в поле поиска заказов. Figma: «search 1 / Size=S · 16». */
export function SearchLine16Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M7.66927 2.66634C4.90785 2.66634 2.66927 4.90492 2.66927 7.66634C2.66927 10.4278 4.90785 12.6663 7.66927 12.6663C10.4307 12.6663 12.6693 10.4278 12.6693 7.66634C12.6693 4.90492 10.4307 2.66634 7.66927 2.66634ZM1.33594 7.66634C1.33594 4.16854 4.17147 1.33301 7.66927 1.33301C11.1671 1.33301 14.0026 4.16854 14.0026 7.66634C14.0026 9.17511 13.475 10.5606 12.5943 11.6486L14.474 13.5283C14.7344 13.7886 14.7344 14.2107 14.474 14.4711C14.2137 14.7314 13.7915 14.7314 13.5312 14.4711L11.6515 12.5914C10.5636 13.4721 9.17804 13.9997 7.66927 13.9997C4.17147 13.9997 1.33594 11.1641 1.33594 7.66634Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 16 16" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Портфель: юрлицо в способах оплаты. Figma: «Outline/Work». */
export function WorkIcon(t0) {
  const $ = _c(10);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 16 : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M7.99609 11.6178C7.72009 11.6178 7.49609 11.3938 7.49609 11.1178V9.42651C7.49609 9.15051 7.72009 8.92651 7.99609 8.92651C8.27209 8.92651 8.49609 9.15051 8.49609 9.42651V11.1178C8.49609 11.3938 8.27209 11.6178 7.99609 11.6178Z" fill="currentColor" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M2.33203 7.59547C3.91603 8.45613 5.91336 8.92747 7.99203 8.92747C10.0747 8.92747 12.074 8.45613 13.6587 7.59547V5.59413C13.6587 4.74413 12.9714 4.05347 12.1254 4.05347H3.87203C3.0227 4.05347 2.33203 4.74147 2.33203 5.58747V7.59547ZM7.99203 9.92747C5.6287 9.92747 3.3507 9.35547 1.57936 8.31813C1.42603 8.2288 1.33203 8.0648 1.33203 7.8868V5.58747C1.33203 4.19013 2.47136 3.05347 3.87203 3.05347H12.1254C13.5227 3.05347 14.6587 4.1928 14.6587 5.59413V7.8868C14.6587 8.0648 14.564 8.2288 14.4114 8.31813C12.64 9.35547 10.36 9.92747 7.99203 9.92747Z" fill="currentColor" />;
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M10.3307 4.05083C10.0547 4.05083 9.83073 3.82683 9.83073 3.55083V3.30683C9.83073 2.77016 9.39406 2.3335 8.8574 2.3335H7.1374C6.60073 2.3335 6.16406 2.77016 6.16406 3.30683V3.55083C6.16406 3.82683 5.94006 4.05083 5.66406 4.05083C5.38806 4.05083 5.16406 3.82683 5.16406 3.55083V3.30683C5.16406 2.21883 6.0494 1.3335 7.1374 1.3335H8.8574C9.9454 1.3335 10.8307 2.21883 10.8307 3.30683V3.55083C10.8307 3.82683 10.6067 4.05083 10.3307 4.05083Z" fill="currentColor" />;
    t5 = <path fillRule="evenodd" clipRule="evenodd" d="M11.8617 14.4934H4.12841C2.74508 14.4934 1.58041 13.4127 1.47575 12.0327L1.34908 10.3601C1.32841 10.0847 1.53508 9.84408 1.81041 9.82341C2.08708 9.81341 2.32575 10.0087 2.34708 10.2847L2.47308 11.9567C2.53841 12.8181 3.26508 13.4934 4.12841 13.4934H11.8617C12.7251 13.4934 13.4524 12.8181 13.5171 11.9567L13.6437 10.2847C13.6651 10.0087 13.9097 9.81275 14.1804 9.82341C14.4557 9.84408 14.6617 10.0847 14.6411 10.3601L14.5144 12.0327C14.4097 13.4127 13.2451 14.4934 11.8617 14.4934Z" fill="currentColor" />;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== props || $[8] !== size) {
    t6 = <Svg size={size} viewBox="0 0 16 16" {...props}>{t2}{t3}{t4}{t5}</Svg>;
    $[7] = props;
    $[8] = size;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}

/** Два человека (лендинг продавца). Figma: «Bold/2 User». */
export function TwoUsersBoldIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M9.34961 14.8574C13.3348 14.8575 16.6982 15.4912 16.6982 17.9404C16.6982 20.3876 13.3133 21 9.34961 21C5.36428 21 2 20.3662 2 17.917C2.00035 15.47 5.38601 14.8574 9.34961 14.8574ZM15.5693 13.3828C17.0847 13.3541 18.7145 13.5584 19.3164 13.7021C20.5921 13.9465 21.4308 14.4438 21.7783 15.1689C22.0728 15.763 22.0728 16.4537 21.7783 17.0479C21.2468 18.1706 19.5325 18.5321 18.8662 18.625C18.7284 18.6439 18.6181 18.5285 18.6328 18.3926C18.9731 15.2809 16.2665 13.8053 15.5654 13.4658C15.5361 13.4495 15.5293 13.4265 15.5322 13.4111C15.5342 13.4016 15.5468 13.3857 15.5693 13.3828ZM9.34961 3C12.0491 3.00014 14.2119 5.11902 14.2119 7.7627C14.2118 10.4062 12.049 12.5243 9.34961 12.5244C6.65107 12.5244 4.48648 10.4063 4.48633 7.7627C4.48633 5.11893 6.65097 3 9.34961 3ZM15.833 3.7959C18.4406 3.7959 20.4877 6.19668 19.79 8.87109C19.3194 10.6735 17.616 11.8702 15.7178 11.8213C15.527 11.8175 15.3402 11.7992 15.1582 11.7695C15.0271 11.7465 14.9609 11.6024 15.0361 11.4951C15.7602 10.4516 16.1729 9.19495 16.1729 7.84863C16.1728 6.44199 15.7222 5.13173 14.9385 4.05566C14.9133 4.02221 14.8949 3.97168 14.9199 3.93262C14.9395 3.90195 14.9794 3.88462 15.0156 3.87695C15.2796 3.82431 15.5504 3.79592 15.833 3.7959Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Три человека (лендинг продавца). Figma: «Bold/3 User». */
export function ThreeUsersBoldIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M11.9491 14.54C15.3802 14.5401 18.3094 15.084 18.3094 17.2607C18.3091 19.4362 15.3988 20 11.9491 20C8.51793 20 5.58782 19.4561 5.58773 17.2803C5.58773 15.1035 8.49907 14.54 11.9491 14.54ZM6.56527 13.2295C6.58496 13.2322 6.59472 13.2468 6.59652 13.2549C6.59902 13.2683 6.59376 13.2875 6.56917 13.3018C5.9621 13.6035 3.61844 14.9161 3.91292 17.6826C3.92546 17.8033 3.83084 17.9058 3.71175 17.8887C3.13505 17.8058 1.65146 17.4851 1.19124 16.4863C0.936257 15.9578 0.936249 15.3459 1.19124 14.8174C1.49208 14.1735 2.2172 13.7297 3.32113 13.5117C3.84312 13.3847 5.25265 13.2052 6.56527 13.2295ZM17.4354 13.2285C18.7467 13.2043 20.1562 13.3848 20.6776 13.5127C21.7816 13.7297 22.5085 14.1725 22.8094 14.8164C23.0637 15.345 23.0636 15.9586 22.8094 16.4863C22.3493 17.4849 20.8658 17.8057 20.2889 17.8887C20.1699 17.9067 20.0735 17.8032 20.0858 17.6836C20.3803 14.9162 18.0378 13.6035 17.4315 13.3018C17.4055 13.2882 17.4005 13.2675 17.4032 13.2549C17.4051 13.2459 17.4158 13.2312 17.4354 13.2285ZM11.9491 4C14.285 4 16.1588 5.88204 16.159 8.23242C16.159 10.5821 14.2852 12.4668 11.9491 12.4668C9.61309 12.4666 7.74007 10.582 7.74007 8.23242C7.7403 5.88214 9.61323 4.00016 11.9491 4ZM6.33675 4.70605C6.58194 4.70608 6.81664 4.73152 7.04573 4.77832C7.07608 4.78552 7.10985 4.80125 7.12777 4.82812C7.14836 4.86235 7.13363 4.90876 7.11214 4.93848C6.43433 5.89402 6.04378 7.05954 6.04378 8.30957C6.04387 9.50721 6.40047 10.6233 7.02718 11.5508C7.09159 11.6462 7.03443 11.7751 6.92073 11.7949C6.76326 11.8228 6.60196 11.8373 6.43734 11.8418C4.79435 11.8849 3.31934 10.8209 2.91195 9.21973C2.30756 6.84123 4.08034 4.70605 6.33675 4.70605ZM17.6639 4.70605C19.9203 4.70605 21.6922 6.84123 21.0887 9.21973C20.6813 10.821 19.2064 11.885 17.5633 11.8418C17.3987 11.8373 17.2365 11.8219 17.0799 11.7949C16.9664 11.775 16.9092 11.6462 16.9735 11.5508C17.6002 10.6232 17.9578 9.50726 17.9578 8.30957C17.9578 7.0596 17.5672 5.89399 16.8895 4.93848C16.868 4.90876 16.8514 4.86235 16.8729 4.82812C16.8908 4.80023 16.9246 4.7865 16.9559 4.7793C17.1842 4.73249 17.4186 4.70606 17.6639 4.70605Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}